import LoadedComponent from "./LoadedComponent";

export default LoadedComponent;
